import { Alert } from 'antd';
import React, { useCallback, useState } from 'react';
import { debounce, get } from 'lodash';

// temp component
// for NBC event to show warning if data is coming from sampled cluster

let setSampledWarningState = (value) => {
  // ignore
};

const checkForScaledFlag = (annotations) => annotations.some(anno => get(anno, ['type'], '') === 'metricScalingEnabled');

export function checkIfSampledCluster(annotations) {
  try {
    const isScaled = checkForScaledFlag(annotations);
    setSampledWarningState(isScaled);
  } catch (err) {
    // ignore
  }
}

const SampledWarningBanner = ({ show = false }) => {
  return show ? (
    <div style={{ margin: '0px 10px' }}>
      <Alert
        style={{ fontSize: 12 }}
        message="Based on sampled data"
        type="warning"
        showIcon
        banner
        />
    </div>
  ) : null;
}

function SampledDataWarning() {
  const [showWarning, setShowWarning] = useState(false);

  setSampledWarningState = useCallback(debounce((value) => {
    setShowWarning(value);
  }, 500), [setShowWarning]);

  return <SampledWarningBanner show={showWarning} />
}

export default SampledDataWarning;
